module.exports = __webpack_public_path__ + "../resources/images/SkyCode_46-ed3d49113dab25371779558764ea914c.svg";